module.exports = __webpack_public_path__ + "img/chr_ts_15.373a9ed6.png";